import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Grid,
	Typography
} from '@mui/material';
import DropDownSingle from '../../../../../Components/DropDownSingle';
import { GAM_GPT_1X1_KEYS, GPT_1X1_TAG_DROPDOWN_LIST } from '../../../../../core/constants';
import InputConfig from '../../../../../Components/InputConfig';

const { INSTREAM_GPT_1X1_TAG } = GAM_GPT_1X1_KEYS;

const GptTagModal = ({
	open,
	onClose,
	onSave,
	tagType,
	setTagType,
	tagSectionId,
	setTagSectionId,
	videoSectionId,
	existing1x1GptTag
}) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				{existing1x1GptTag?.sectionId ? 'Edit 1x1 Tag' : 'Create 1x1 Tag'}
			</DialogTitle>

			<DialogContent>
				<Typography sx={{ mb: 3 }}>
					Fill the details to generate a 1x1 tag.
				</Typography>

				<Grid container spacing={2}>
					<Grid item xs={12}>
						<DropDownSingle
							label="1x1 TAG TYPE"
							list={GPT_1X1_TAG_DROPDOWN_LIST}
							isObjectEditor={false}
							directValue={tagType}
							updateDirectValue={(val) => {
								setTagType(val);
								setTagSectionId('');
							}}
							formControlStyles={{ width: '100%' }}
						/>
					</Grid>

					<Grid item xs={12}>
						<InputConfig
							label="Instream section ID"
							isObjectEditor={false}
							editable={false}
							directValue={videoSectionId}
						/>
					</Grid>

					{/* Only show when needed */}
					{tagType !== INSTREAM_GPT_1X1_TAG && (
						<Grid item xs={12}>
							<InputConfig
								label="ApTag section ID"
								isObjectEditor={false}
								directValue={tagSectionId}
								updateDirectValue={(val) => setTagSectionId(val)}
								placeholder="ApTag Section ID"
								showInfoButton={true}
								infoMessage="Please provide the ApTag Section ID from the AdPushup console"
								isMandatory={true}
							/>
						</Grid>
					)}
				</Grid>
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose} variant="outlined">
					Cancel
				</Button>
				<Button onClick={onSave} variant="contained" color="error">
					{existing1x1GptTag?.sectionId ? 'Update Tag' : 'Create Tag'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default GptTagModal;
